export default {
  FormImport: require('./FormImport').default,
}
